class carditemmodel {
  constructor(img,title,phone){
    this.img = img;
    this.title = title;
    this.phone = phone;
  }
}

export {
  carditemmodel
}